import {Integer} from '@pb/kit-component-formatters';

import {
    COLUMNS,
    HEADERS,
} from './constants';

import type {Locale} from '@pb/kit-context-locale';

export const getHeader = (locale: Locale, totalCount?: number) => {
    const caption = HEADERS[COLUMNS.EMAIL];
    if (totalCount) {
        return caption + (totalCount ? ` (${Integer.format(totalCount, locale)})` : '');
    }

    return caption;
};

